'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
(function(MessageDesign2) {
  MessageDesign2[MessageDesign2["GENERAL_NOTIFICATION"] = 0] = "GENERAL_NOTIFICATION";
  MessageDesign2[MessageDesign2["FREE_SPINS"] = 1] = "FREE_SPINS";
  MessageDesign2[MessageDesign2["RELOAD_BONUS"] = 2] = "RELOAD_BONUS";
  MessageDesign2[MessageDesign2["FREE_MONEY_BONUS"] = 3] = "FREE_MONEY_BONUS";
  MessageDesign2[MessageDesign2["HAPPY_HOURS"] = 4] = "HAPPY_HOURS";
  MessageDesign2[MessageDesign2["DOUBLE_RELOAD"] = 5] = "DOUBLE_RELOAD";
  MessageDesign2[MessageDesign2["FIXED_RELOAD"] = 6] = "FIXED_RELOAD";
  MessageDesign2[MessageDesign2["FESTIVAL"] = 7] = "FESTIVAL";
  MessageDesign2[MessageDesign2["FREE_FALL_CHALLENGE"] = 8] = "FREE_FALL_CHALLENGE";
  MessageDesign2[MessageDesign2["DEPOSIT_AND_FREE_SPINS"] = 9] = "DEPOSIT_AND_FREE_SPINS";
  MessageDesign2[MessageDesign2["NEW_GAME"] = 10] = "NEW_GAME";
  MessageDesign2[MessageDesign2["SURPRISE_BUNNY"] = 11] = "SURPRISE_BUNNY";
  MessageDesign2[MessageDesign2["EASTER_EGG"] = 12] = "EASTER_EGG";
  MessageDesign2[MessageDesign2["SUMMER"] = 13] = "SUMMER";
  MessageDesign2[MessageDesign2["BONUS_METRE"] = 14] = "BONUS_METRE";
  MessageDesign2[MessageDesign2["REGISTRATION"] = 15] = "REGISTRATION";
  MessageDesign2[MessageDesign2["HALLOWEEN"] = 16] = "HALLOWEEN";
  MessageDesign2[MessageDesign2["CHRISTMAS"] = 17] = "CHRISTMAS";
  MessageDesign2[MessageDesign2["REWARD"] = 18] = "REWARD";
  MessageDesign2[MessageDesign2["PERSONAL_NOTE"] = 19] = "PERSONAL_NOTE";
  MessageDesign2[MessageDesign2["CASINO"] = 20] = "CASINO";
  MessageDesign2[MessageDesign2["SPORTSBOOK"] = 21] = "SPORTSBOOK";
  MessageDesign2[MessageDesign2["DEPOSIT"] = 22] = "DEPOSIT";
  MessageDesign2[MessageDesign2["PLAY"] = 23] = "PLAY";
  MessageDesign2[MessageDesign2["SUCCESS"] = 24] = "SUCCESS";
  MessageDesign2[MessageDesign2["GENERIC"] = 25] = "GENERIC";
})(exports.MessageDesign || (exports.MessageDesign = {}));
(function(MessagePriority2) {
  MessagePriority2[MessagePriority2["PROMOTION"] = 0] = "PROMOTION";
  MessagePriority2[MessagePriority2["POP_OPEN"] = 1] = "POP_OPEN";
  MessagePriority2[MessagePriority2["IMPORTANT"] = 2] = "IMPORTANT";
  MessagePriority2[MessagePriority2["BIG_PROMOTION"] = 3] = "BIG_PROMOTION";
  MessagePriority2[MessagePriority2["LOW_PRIORITY"] = 4] = "LOW_PRIORITY";
})(exports.MessagePriority || (exports.MessagePriority = {}));
(function(MessageStatus2) {
  MessageStatus2["READ"] = "R";
  MessageStatus2["DELETED"] = "D";
  MessageStatus2["CANCELLED"] = "C";
  MessageStatus2["NEW"] = "N";
})(exports.MessageStatus || (exports.MessageStatus = {}));
(function(MessageType2) {
  MessageType2[MessageType2["CAMPAIGN"] = 0] = "CAMPAIGN";
  MessageType2[MessageType2["AD_HOC"] = 1] = "AD_HOC";
  MessageType2[MessageType2["ALERTS"] = 2] = "ALERTS";
  MessageType2[MessageType2["AFFILIATE"] = 3] = "AFFILIATE";
  MessageType2[MessageType2["BONUS"] = 4] = "BONUS";
  MessageType2[MessageType2["VIP"] = 5] = "VIP";
  MessageType2[MessageType2["NOTIFICATION"] = 6] = "NOTIFICATION";
  MessageType2[MessageType2["PLAY_SAFE"] = 7] = "PLAY_SAFE";
})(exports.MessageType || (exports.MessageType = {}));
function unlocalize(msg, lang) {
  return __spreadProps(__spreadValues({}, msg), {
    subject: msg.subject ? msg.subject[lang] : void 0,
    body: msg.body ? msg.body[lang] : void 0,
    image: msg.image ? msg.image[lang] : void 0,
    link: msg.link ? msg.link[lang] : void 0,
    link2: msg.link2 ? msg.link2[lang] : void 0,
    tnc: msg.tnc ? msg.tnc[lang] : void 0,
    status: msg.status || exports.MessageStatus.NEW
  });
}

exports.unlocalize = unlocalize;
